import React, { useEffect, useState } from 'react';
import { fetchDiaryEntry, saveDiaryEntry } from '../../services/api';
import DiaryNoteForm from './DiaryNoteForm';

const DiaryNoteSection = ({
  topic,
  exerciseType = null,
  noteType = 'exercise',
  required = false,
  title = 'Poznámka do deníku',
  buttonLabel = 'Přidat poznámku do deníku'
}) => {
  const [note, setNote] = useState('');
  const [showForm, setShowForm] = useState(required);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const loadEntry = async () => {
      try {
        const entry = await fetchDiaryEntry(topic, noteType, exerciseType);
        if (entry && entry.note) {
          setNote(entry.note);
          setSaved(true);
        }
      } catch (error) {
        console.error('Error loading diary entry:', error);
      } finally {
        setLoading(false);
      }
    };

    loadEntry();
  }, [topic, noteType, exerciseType]);

  if (!showForm) {
    return (
      <div className="flex justify-center mb-6">
        <button
          className="px-6 py-3 rounded-lg font-medium border-2 border-rose-500 text-rose-500 hover:bg-rose-50 transition-colors"
          onClick={() => setShowForm(true)}
        >
          {buttonLabel}
        </button>
      </div>
    );
  }

  return (
    <DiaryNoteForm
      title={title}
      note={note}
      onNoteChange={setNote}
      required={required}
      saveLabel={saving ? 'Ukládám...' : 'Uložit do deníku'}
      inputDisabled={loading || saving}
      buttonDisabled={loading || saving || !note.trim()}
      statusMessage={saved ? 'Poznámka uložena.' : ''}
      onSave={async () => {
        if (!note.trim()) {
          return;
        }
        try {
          setSaving(true);
          await saveDiaryEntry({
            topic,
            noteType,
            exerciseType,
            note: note.trim()
          });
          setSaved(true);
        } catch (error) {
          console.error('Error saving diary entry:', error);
        } finally {
          setSaving(false);
        }
      }}
    />
  );
};

export default DiaryNoteSection;
